import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: '80vh'
    },
    numberOfScenes: {
        ...theme.typography.h6,
        color: theme.palette.text.secondary
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    playlistName: {
        ...theme.typography.h6,
        color: theme.palette.text.primary,
        marginLeft: 20
    }
}));

export {useStyles};